/* eslint-disable no-unused-vars */
import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import ChartContent from './ChartContent';

import styles from './Report.module.scss';

const Report = React.memo(
  ({
    isEditable,
    items,
    dailyReportWk,
    monthlyReportWk,
    yearlyReportWk,
    onChangeDaily,
    onChangeDailyInterval,
    onChangeMonthly,
    onChangeYearly,
    onFetchReports,
  }) => {
    const [t] = useTranslation();

    const savedDailyReport = useRef(dailyReportWk);
    const savedMonthlyReport = useRef(monthlyReportWk);
    const savedYearlyReport = useRef(yearlyReportWk);

    console.log('********************** Chart render');

    /* prevent re-rendering */
    if (JSON.stringify(savedDailyReport.current) !== JSON.stringify(dailyReportWk)) {
      savedDailyReport.current = dailyReportWk;
    }

    if (JSON.stringify(savedMonthlyReport.current) !== JSON.stringify(monthlyReportWk)) {
      savedMonthlyReport.current = monthlyReportWk;
    }

    if (JSON.stringify(savedYearlyReport.current) !== JSON.stringify(yearlyReportWk)) {
      savedYearlyReport.current = yearlyReportWk;
    }

    const panes = [
      {
        menuItem: t('common.reports.day'),
        render: () => (
          <Tab.Pane>
            <ChartContent
              isEditable={isEditable}
              type="daily"
              items={items}
              reports={savedDailyReport.current}
              onChangeDate={onChangeDaily}
              onChangeDateInterval={onChangeDailyInterval}
              onFetchReports={onFetchReports}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.reports.month'),
        render: () => (
          <Tab.Pane>
            <ChartContent
              isEditable={isEditable}
              type="monthly"
              items={items}
              reports={savedMonthlyReport.current}
              onChangeDate={onChangeMonthly}
              onFetchReports={onFetchReports}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.reports.year'),
        render: () => (
          <Tab.Pane>
            <ChartContent
              isEditable={isEditable}
              type="yearly"
              items={items}
              reports={savedYearlyReport.current}
              onChangeDate={onChangeYearly}
              onFetchReports={onFetchReports}
            />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div className={styles.devicesWrapper}>
        <h2 className="page-title">{t('common.report')}</h2>
        <Tab panes={panes} />
      </div>
    );
  },
);

Report.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  dailyReportWk: PropTypes.objectOf(PropTypes.any).isRequired,
  monthlyReportWk: PropTypes.objectOf(PropTypes.any).isRequired,
  yearlyReportWk: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeDaily: PropTypes.func.isRequired,
  onChangeDailyInterval: PropTypes.func.isRequired,
  onChangeMonthly: PropTypes.func.isRequired,
  onChangeYearly: PropTypes.func.isRequired,
  onFetchReports: PropTypes.func.isRequired,
};

export default Report;
